<script setup>
/**
 * FormControlPlainText
 * Lightweight presentational row wrapper for read-only values.
 * Inspects global form-size configuration metrics out of state containers,
 * dynamically managing cell spacing metrics for unified administrative grids.
 */
import { computed, getCurrentInstance } from 'vue';

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    value: {
        type: [String, Number],
        default: ''
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Synchronous Computeds ---

/**
 * Accesses systemic form padding specifications to compress grid footprints.
 */
const formSmall = computed(() => {
    return store.state[props.formId]?.formSmall || false;
});
</script>

<template>
    <p
        class="bg-body-tertiary rounded text-break"
        :class="{ 'px-2 py-1 small': formSmall, 'p-2': !formSmall }"
    >
        {{ value }}

        <slot />
    </p>
</template>

<style scoped>
/* Visual Safety Anchor:
    Forces the paragraph block to maintain a uniform structural height
    even if the backing database field value is null or completely blank.
*/
p::after {
    content: " ";
    font-size: 0;
    white-space: pre;
}
</style>